import React from 'react';
import PropTypes from 'prop-types';
import { ListFacetGroup } from '../ListFacetGroup';
import BooleanFacet from '../BooleanFacet';
import Rating from '@mui/material/Rating';

const StarFacet = ({ name, selected, onChange, facets }) => {
  const selectedValues = selected.map(x => parseInt(x));
  const counts = [
    0, // 0 Stars
    0, // 1 Stars
    0, // 2 Stars
    0, // 3 Stars
    0, // 4 Stars
    0 // 5 Stars
  ];

  facets.forEach(f => {
    counts[parseInt(f.value)] = f.count;
  });

  return (
    <ListFacetGroup
      name={name}
    >
      {[5, 4, 3, 2, 1].map(starRating => (
        <BooleanFacet
          key={starRating}
          onChange={() => {
            if (selectedValues.indexOf(starRating) === -1) {
              onChange([...selectedValues, starRating]);
            } else {
              onChange([...selectedValues.filter(x => x !== starRating)]);
            }
          }}
          name={<Rating name="read-only" size="small"  value={starRating} readOnly />}
          selected={selectedValues.indexOf(starRating) !== -1}
          count={counts[starRating]}
        />
      ))}
    </ListFacetGroup>
  );
};

export default StarFacet;
export { StarFacet };

StarFacet.propTypes = {
  name: PropTypes.node.isRequired,
  selected: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ])
  ),
  onChange: PropTypes.func.isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape({
    'value': PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    'count': PropTypes.number.isRequired
  }))
};
StarFacet.defaultProps = {
  selected: [],
  facets: []
};